// ----------------------------------------------------------------------

const polls = [
  {
    id: 1,
    title: 'test',
    question: 'test',
    optiona: 'a',
    optionb: 'b',
    optionc: 'c',
    optiond: 'd',
    polltype: 'Optional',
    starttime: '2022-01-16 18:47 UTC',
    endtime: '2022-01-16 18:57 UTC',
    result: '1',
    status: 'Active'
  },
  {
    id: 2,
    title: 'test2',
    question: 'test2',
    optiona: 'a',
    optionb: 'b',
    optionc: 'c',
    optiond: 'd',
    polltype: 'Subjective',
    starttime: '2022-01-16 18:47 UTC',
    endtime: '2022-01-16 18:57 UTC',
    result: '1',
    status: 'Inactive'
  },
  {
    id: 3,
    title: 'test',
    question: 'test',
    optiona: 'a',
    optionb: 'b',
    optionc: 'c',
    optiond: 'd',
    polltype: 'Optional',
    starttime: '2022-01-16 18:47 UTC',
    endtime: '2022-01-16 18:57 UTC',
    result: '1',
    status: 'Active'
  },
  {
    id: 4,
    title: 'test',
    question: 'test',
    optiona: 'a',
    optionb: 'b',
    optionc: 'c',
    optiond: 'd',
    polltype: 'Optional',
    starttime: '2022-01-16 18:47 UTC',
    endtime: '2022-01-16 18:57 UTC',
    result: '1',
    status: 'Active'
  }
];

export default polls;
